import { styled } from "theme/default/styled";
import { setFlexDFJCSB } from "theme/setter/setFlexValues/setFlexDFJCSB";

export const SUserResetPasswordFormButtons = styled.div`
  margin-top: auto;

  ${setFlexDFJCSB};
`;
